<script>
    import lookups from '../stores/lookupStore';
    import Person from '../models/Person';

    import TextInput from './TextInput.svelte';
    import Select from './Select.svelte';
    import FormRow from './FormRow.svelte';
    import FormColumn from './FormColumn.svelte';

    export let registration;
    export let claimants;
    export let disabled = null;

    if (!claimants || !claimants.length) {
        claimants = [ new Person() ];
    }

    // My temp fix to dropdown having value as string and property being int.
    // This is due to ProjectAssociate.RelationshipToClaimant being nvarchar,
    // and lookup id being int.
    let someoneElseRelationshipList = [];
    if ($lookups.someoneElseRelationship){
        someoneElseRelationshipList = $lookups.someoneElseRelationship.map((object) => ({
            ...object,
            idStr: object.id.toString(),
        }));
    }
</script>


<FormRow>
    <FormColumn cols="6">
        <TextInput label="First name" required {disabled} bind:value="{claimants[0].firstName}" id="s_firstName" />
    </FormColumn>
    <FormColumn cols="6">
        <TextInput label="Last name" required {disabled} bind:value="{claimants[0].surname}" id="s_surname" />
    </FormColumn>
</FormRow>

<FormRow>
    <FormColumn>
        <Select id="cap"
            required
            {disabled}
            label="Please specify your relationship to the claimant"
            bind:value="{registration.relationshipToClaimant}"
            optionList="{someoneElseRelationshipList}"
            textProperty="lookupName"
            valueProperty="idStr"
        ></Select>
    </FormColumn>
</FormRow>
